/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import ProfileComponent from './profile';
import LoggedInMeTopbar from 'layout/topbar/logged-in-me';

export const profile = (context, next) => {
    context.primary = <ProfileComponent />;
    next();
};


export const navigation = (context, next) => {
	context.topbar = <LoggedInMeTopbar path={context.path}/>;
    next();
};